import React, { useEffect, useState } from "react"
import styles from "./site-categories.module.css"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import {
  isChrome,
  isChromium,
  isEdge,
  isFirefox,
  isIE,
  isMobileSafari,
  isOpera,
  isSafari,
  isYandex
} from "react-device-detect"

const SiteCategories = () => {

  const [isFacebook, setIsFacebook] = useState(false)

  useEffect(() => {
    setIsFacebook(!isChrome && !isFirefox && !isSafari && !isOpera && !isIE && !isEdge && !isYandex && !isChromium && !isMobileSafari)
  }, [])

  const data = useStaticQuery(graphql`
      query {
          img1: file(relativePath: { eq: "categories/strollers.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img2: file(relativePath: { eq: "categories/pushchairs.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img3: file(relativePath: { eq: "categories/mealtimes.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img4: file(relativePath: { eq: "categories/clothing.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img5: file(relativePath: { eq: "categories/specials.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img6: file(relativePath: { eq: "categories/bathtime.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img7: file(relativePath: { eq: "categories/car-seats.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img8: file(relativePath: { eq: "categories/doubles.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img9: file(relativePath: { eq: "categories/nursery.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img10: file(relativePath: { eq: "categories/rockers.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img11: file(relativePath: { eq: "categories/toys.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img12: file(relativePath: { eq: "categories/travel.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img13: file(relativePath: { eq: "categories/accessories.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img14: file(relativePath: { eq: "categories/buggy-boards.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img15: file(relativePath: { eq: "categories/changing.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img16: file(relativePath: { eq: "categories/footmufs.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img17: file(relativePath: { eq: "categories/cribs.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img18: file(relativePath: { eq: "categories/pram-accessories.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img19: file(relativePath: { eq: "categories/baby-monitors.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          img20: file(relativePath: { eq: "categories/safety.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 300) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <div className={styles.categories}>
      <div className={styles.commonHeader}>
        <h1 className={styles.commonHeading}>All Categories</h1>
        <div className={styles.underline}>
          <div className={styles.smallUnderline}/>
          <div className={styles.largeUnderline}/>
        </div>
      </div>

      <div className={styles.categoryCardsWrapper}>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="strollers" fluid={data.img1.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Strollers</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577932869092126&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="pushchairs" fluid={data.img2.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Pushchairs</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577903262428420&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="mealtime" fluid={data.img3.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Mealtime</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577917695760310&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="clothing" fluid={data.img4.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Clothing</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577924612426285&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="specials" fluid={data.img5.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Specials</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577944849090928&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="bath time" fluid={data.img6.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Bath time</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577922819093131&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="swings and rockers" fluid={data.img10.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Swings & Rockers</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577942119091201&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="double and triple pushchairs"
               fluid={data.img8.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Double / Triple Pushchairs</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577906149094798&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="nursery" fluid={data.img9.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Nursery</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577914685760611&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="car seats" fluid={data.img7.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Car Seats</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577909352427811&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="toys" fluid={data.img11.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Toys</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577936615758418&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="travel systems" fluid={data.img12.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Travel Systems</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2577897499095663&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="accessories" fluid={data.img13.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Accessories</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2581768245375255&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="buggy boards" fluid={data.img14.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Buggy Boards</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2581633442055402&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="Changing Bags" fluid={data.img15.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Changing Bags</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2581740545378025&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="footmuffs" fluid={data.img16.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Footmuffs</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2581604362058310&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="cribs" fluid={data.img17.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Cribs & Sleepers</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2582697461949000&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="pram accessories" fluid={data.img18.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Pram Accessories</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2582688251949921&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="baby monitors" fluid={data.img19.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Baby Monitors</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2582711445280935&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>

        <div className={styles.categoryCard}>
          <Img className={styles.categoryImage} alt="safety" fluid={data.img20.childImageSharp.fluid}/>
          <div className={styles.categoryCardContent}>
            <h4 className={styles.categoryCardHeading}>Safety</h4>
            <button className={styles.categoryCardBtn}>
              {isFacebook ?
                <a href="fb://page/1542669702618453">View</a>
                :
                <a
                  href="https://apps.facebook.com/pg/jollybaby123/photos/?tab=album&album_id=2582688088616604&ref=page_internal"
                  target="_blank" rel="noopener noreferrer">View</a>
              }
            </button>
          </div>
        </div>
      </div>
      <hr className='divider'/>
    </div>
  )
}

export default SiteCategories
